var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { NotificationUtils } from "@yodlee/common-components/dist/utilities";
import { Col, Divider, Form, Icon, Row, Spin } from "antd";
import moment from "moment";
import React from "react";
import MediaQuery from "react-responsive";
import { DataUtils, ParserUtils } from "../../utilities";
import LeftView from "./left-view";
import RightView from "./right-view";
var CreateMaintenance = /** @class */ (function (_super) {
    __extends(CreateMaintenance, _super);
    function CreateMaintenance() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false,
            isPreview: false,
            onFormUpdated: false
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            var onFormUpdate = _this.props.onFormUpdate;
            var isFieldsTouched = _this.props.form.isFieldsTouched;
            var onFormUpdated = _this.state.onFormUpdated;
            var oldOnFormUpdated = prevState.onFormUpdated;
            if (onFormUpdate && isFieldsTouched() && !onFormUpdated && !oldOnFormUpdated) {
                _this.setState({
                    onFormUpdated: true
                }, function () {
                    onFormUpdate();
                });
            }
        };
        _this.componentDidMount = function () {
            var _a = _this.props, authentication = _a.authentication, maintenance = _a.maintenance;
            DataUtils.systemConfig(authentication).get().then(function (onload) {
                _this.setState({ onload: onload });
            });
            if (maintenance === null || maintenance === void 0 ? void 0 : maintenance.id) {
                DataUtils.maintenances(authentication).getOne(maintenance.id).then(function (maintenance) {
                    _this.setState({ maintenance: maintenance, isPreview: false });
                });
            }
        };
        _this.downloadAttachment = function (attachmentId, fileName) {
            var authentication = _this.props.authentication;
            var maintenance = _this.state.maintenance;
            if (maintenance === null || maintenance === void 0 ? void 0 : maintenance.id) {
                DataUtils.maintenances(authentication).downloadAttachment(maintenance.id, attachmentId, fileName);
            }
        };
        _this.onSubmit = function (e, isPublish) {
            if (isPublish === void 0) { isPublish = true; }
            var validateFieldsAndScroll = _this.props.form.validateFieldsAndScroll;
            var _a = _this.props, authentication = _a.authentication, onCreate = _a.onCreate, onUpdate = _a.onUpdate;
            var _b = _this.state, isPreview = _b.isPreview, maintenance = _b.maintenance;
            e.preventDefault();
            e.stopPropagation();
            validateFieldsAndScroll(function (err, values) {
                var _a;
                console.debug('Received values of serviceRequestForm: ', values, err);
                if (!err) {
                    if (isPreview || maintenance) {
                        if (isPublish ? values.reviewedBy : true) {
                            _this.setState({
                                isLoading: true
                            });
                            var newMaintenance_1 = __assign({}, values);
                            newMaintenance_1.isPublish = isPublish;
                            newMaintenance_1.startTime = newMaintenance_1.startTime ? moment(newMaintenance_1.startTime).valueOf() : undefined;
                            newMaintenance_1.endTime = newMaintenance_1.endTime ? moment(newMaintenance_1.endTime).valueOf() : undefined;
                            if (!maintenance) {
                                newMaintenance_1.brands = [];
                                newMaintenance_1.selectedBrandInfos.filter(function (brandInfo) { return newMaintenance_1.to.includes(brandInfo.index); }).map(function (brandInfo) { return ({ id: brandInfo.id, name: brandInfo.name }); }).forEach(function (brand) {
                                    if (!newMaintenance_1.brands.find(function (item) { return item.id === brand.id; })) {
                                        newMaintenance_1.brands.push(brand);
                                    }
                                });
                                delete newMaintenance_1.to;
                                delete newMaintenance_1.selectedBrandInfos;
                            }
                            if (newMaintenance_1.downTime && newMaintenance_1.downTime.type.id === -1) {
                                delete newMaintenance_1.downTime;
                            }
                            else {
                                var parsedValues = ParserUtils.parseTimeUnit(newMaintenance_1.downTime.estimatedDuration, false);
                                if (parsedValues.unit === "minutes") {
                                    newMaintenance_1.downTime.estimatedDuration = "PT".concat(parsedValues.value, "M");
                                }
                                else {
                                    newMaintenance_1.downTime.estimatedDuration = "PT".concat(parsedValues.value, "H");
                                }
                            }
                            if (newMaintenance_1.nextUpdateValue) {
                                newMaintenance_1.nextUpdatePeriod = newMaintenance_1.nextUpdateValue;
                                delete newMaintenance_1.nextUpdateValue;
                            }
                            if (newMaintenance_1.reviewedBy) {
                                newMaintenance_1.reviewedBy = JSON.parse(newMaintenance_1.reviewedBy);
                            }
                            var formData_1 = new FormData();
                            if (newMaintenance_1.files) {
                                (_a = newMaintenance_1.files) === null || _a === void 0 ? void 0 : _a.forEach(function (file) {
                                    formData_1.append("attachments", file.originFileObj);
                                });
                                delete newMaintenance_1.files;
                            }
                            var maintenanceRequestBlob = new Blob([JSON.stringify(newMaintenance_1)], {
                                type: 'application/json'
                            });
                            formData_1.append("maintenanceRequest", maintenanceRequestBlob);
                            if (maintenance && maintenance.id) {
                                DataUtils.maintenances(authentication).updateOne(maintenance.id, formData_1).then(function (maintenance) {
                                    onUpdate && onUpdate(maintenance);
                                }).finally(function () {
                                    _this.setState({
                                        isLoading: false,
                                        onFormUpdated: false
                                    });
                                });
                            }
                            else {
                                DataUtils.maintenances(authentication).createOne(formData_1).then(function (maintenance) {
                                    onCreate && onCreate(maintenance);
                                }).finally(function () {
                                    _this.setState({
                                        isLoading: false
                                    });
                                });
                            }
                        }
                        else {
                            NotificationUtils.warning("Reviewed by is missing", "Please provide reviewed by to publish");
                        }
                    }
                    else {
                        _this.setState({ isPreview: true });
                    }
                    ;
                }
            });
        };
        _this.render = function () {
            var _a = _this.state, onload = _a.onload, isPreview = _a.isPreview, maintenance = _a.maintenance, isLoading = _a.isLoading;
            var authentication = _this.props.authentication;
            return (onload ?
                React.createElement(MediaQuery, { minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD }, function (matches) {
                    return React.createElement(Form, { colon: false, layout: "horizontal", className: "bold-label", onSubmit: _this.onSubmit },
                        React.createElement(Row, { type: "flex", style: { width: '100%' } },
                            React.createElement(Col, { xxl: 7, xl: 7, lg: 7, md: 24, sm: 24, xs: 24, order: matches ? 1 : 3, className: matches ? "padding-right-lg" : "" },
                                React.createElement(LeftView, { maintenance: maintenance, onload: onload, form: _this.props.form, authentication: authentication, isPreview: isPreview })),
                            React.createElement(Col, { xs: 24, sm: 24, md: 24, lg: 0, xl: 0, xxl: 0, order: 2 },
                                React.createElement(Divider, null)),
                            React.createElement(Col, { xxl: 17, xl: 17, lg: 17, md: 24, sm: 24, xs: 24, order: matches ? 3 : 1, className: matches ? "padding-left-lg border-left" : "" },
                                React.createElement(RightView, { isLoading: isLoading, maintenance: maintenance, onload: onload, form: _this.props.form, authentication: authentication, isPreview: isPreview, toggleIsPreview: function () { return _this.setState({ isPreview: !isPreview }); }, onSubmit: function (e, isPublish) { return _this.onSubmit(e, isPublish); }, downloadAttachment: _this.downloadAttachment }))));
                }) :
                React.createElement(Row, { type: "flex", style: { height: "80vh" }, justify: "center", align: "middle" },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
        };
        return _this;
    }
    return CreateMaintenance;
}(React.Component));
export default Form.create({ name: 'create-maintenance' })(CreateMaintenance);
//# sourceMappingURL=index.js.map